import React, { Component } from "react";
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import { resetPwdAction } from 'actions/adminActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  Input,
  InputGroupText,
  InputGroup
} from "reactstrap";

class AdminResetPwd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false
    }
  }

  componentWillMount() {
    document.title = 'Reset Password';
    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/resetpwd';
    }
  }

  componentWillUnmount() {
    if(this.props.response.register.response !== 'undefined')
      delete this.props.response.admin.response;
  }

  render() {
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }

    let isSuccess, message;

    if (this.props.response.admin.hasOwnProperty('response') && 
          this.props.response.admin.response !== undefined){
      if(this.props.response.admin.response.hasOwnProperty('status') &&
          this.props.response.admin.response.status !== undefined)
        if(this.props.response.admin.response.status === 'success')
          isSuccess = true;
        else if(this.props.response.register.response.status === 'error'){
          isSuccess = false;
          message = 'Sairam! Reset password is NOT successful';
        }
    }

    if(isSuccess)
      message = 'Sairam! Reset password is successful';
    
    return (      
      <Formik
            initialValues={{
                username: '',
                newPassword: ''
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string()
                    .required('username is required'),
              newPassword: Yup.string()                
                    .required('password is required'),                    
            })}
        onSubmit={fields => {
            let username = fields.username;            
            let newPassword = fields.newPassword;  
            let token = this.props.response.login.userToken;
            const data = {
              username, newPassword
            }

            const payload = {
              token, data
            }

            if(this.props.response.login.isSuperAdmin ||
              this.props.response.login.isStateAdmin)
              this.props.dispatch(resetPwdAction(payload));
        }  
      }
        render={({ errors, status, touched }) => (                    
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Reset Admin Password                            
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                      {(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin) ? '' : 'Sairam! You dont have access to reset admin password'}
                      {message}
                      <Form>                      
                      <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Username
                      </InputGroupText>
                    <Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                    <ErrorMessage name="username" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.lastFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Password
                      </InputGroupText>
                    <Field name="newPassword" type="password" className={'form-control' + (errors.newPassword && touched.newPassword ? ' is-invalid' : '')} />
                    <ErrorMessage name="newPassword" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <div className="col text-center">
                  <button disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)} type="submit" size="lg" outline className="btn btn-primary">Reset Password</button>
                  </div>
                      </Form>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)(AdminResetPwd);